import { Div } from 'alkali'
import * as starIcon from 'icons/rating-star.svg'
import * as syncIcon from 'icons/common-file-sync.svg'
import * as lockIcon from 'icons/lock-1.svg'
import * as unlockIcon from 'icons/lock-unlock.svg'
import * as loadingIcon from 'icons/loading-half.svg'
import Icon from 'components/Icon'
import { locked, analysisSelections, isLiveEditing, faqOrReadOnly, docSearchQuery  } from 'model/SearchQuery'
import { questionLabel } from 'analysis/Question'
import { recordStudySelections } from 'model/StudyCollection'
import { questionToText } from 'analysis/Question'
import { put, post, patch } from 'tools/request'
import { favoriteQuery, favorite, availableQuestions } from 'model/AvailableAnalyses'
import app from 'app/app'
export class FavoriteControl extends Div('.icon-wrapper') {
	created(properties) {
		properties.content = [
			Icon('.favorite-question', {
				classes: {
					'filled-icon': faqOrReadOnly.to(faq => faq && favorite),
				},
				icon: favorite.to(favorite => favorite ?
					locked.to(async locked => (await faqOrReadOnly) ? starIcon :
						locked ?
							isLiveEditing.to(isLiveEditing => isLiveEditing ? syncIcon : lockIcon) : unlockIcon) : starIcon),
				title: favorite.to(favorite => favorite ? 
					locked.to(locked => locked ? 
						isLiveEditing.to(isLiveEditing => isLiveEditing ?
						'Currently editing saved question and selections' : 'This question is locked') : 
						'This query is favorited and auto-saving changes, click to snapshot and lock the question') : 'Save this question and selections as a favorite'),
				async onclick() {
					this.classList.add('spinner')
					try {
						await saveFavorite()
					} catch(error) {
						alert('Unable to save favorite: ' + error.message)
					}
					this.classList.remove('spinner')
				}
			})
		]
	}
}
async function saveFavorite() {
	let dsSearch = docSearchQuery.valueOf()
	let dsQueryText
	if (dsSearch?.query) {
		let names = []
		dsSearch.query.replace(/\([^\(\)\.]+\.([^\)]+)\)/g, (t, name) => {
			names.push(name)
		})
		dsQueryText = dsSearch.name + ' (' + (names.length > 0 ? names.join(', ') : '') + ')'
		if (!favorite.valueOf()) {
			if (!confirm('This is specifically using a DOC Search query' +
					(dsQueryText && (' of ' + dsQueryText) || '')  + '. Would you like to save this as a favorite?'))
				return
		}
	}
	if (isLiveEditing.valueOf()) {
		return isLiveEditing.put(false)
	}
	const questionText = analysisSelections.studyFilter?.importCollection.valueOf()
		? (analysisSelections.studyFilter?.importCollection.valueOf() + (analysisSelections.question.length > 1 ? ` - ${questionToText(analysisSelections.question.valueOf())}` : ''))
		: analysisSelections.dsQuery?.name.valueOf() 
			? (dsQueryText + (analysisSelections.question.length > 1 ? ` - ${questionToText(analysisSelections.question.valueOf())}` : ''))
			: questionToText(analysisSelections.question) 
	if (favorite.valueOf()) {
		if (await faqOrReadOnly) {
			try {
				if (await unfavoriteAnalysisSelections(analysisSelections.valueOf()))
					alert('"' + questionText + '" was unfavorited')
				return
			} catch (error) {
				return alert(error)
			}
		}
		if (locked.valueOf())
			return alert('This question ' + (dsQueryText && ('("' + dsQueryText + '"), ') || '') + 'has already been locked and saved.')
		else {
			recordStudySelections()
			locked.put(true)
			let selections = analysisSelections.valueOf()
			await put('/portal/AnalysisSelections/' + selections.id, {
				data: selections
			})
			return alert('"' + questionText + '" was locked')
		}
	}
	return favoriteQuery().then(() => {
		alert('"' + questionText + '" was saved as a favorite')
	})
}

export async function unfavoriteAnalysisSelections(analysis) {
	if (confirm('Are you sure you want to unfavorite the question "' + questionLabel(analysis || []) + '"?')) {
		if (analysis.favorite && analysis.owner == app.user.Id)
			await patch('/portal/AnalysisSelections/' + analysis.id, {
				data: {
					favorite: false
				}
			})
		else
			await post('/portal/AnalysisSelections/' + analysis.id, {
				data: {
					method: 'unfavorite',
					dashboard: !!window.isFAQDashboard,
				}
			})
		availableQuestions.updated()
		favorite.updated()
		return true
	}
}
